<script setup lang="ts">
import { ref } from 'vue';
import { getLabel } from '@/utils/data-display-utils';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseSelect from '@/components/base/BaseSelect.vue';

import { getTranslation } from '@/utils/data-display-utils';
import { useField } from 'vee-validate';
import { Locales } from '@/store/language.interface';

// CONST
const markerInputCategory = ref(null);

// PROPS
const props = defineProps<{
  mapConfig: any;
  languageEnabled?: Locales[];
}>();

// EMITS
const emit = defineEmits<{
  (e: 'changeCategory', category): void;
}>();

// FORM
const { value: comment, errorMessage: errorMessageComment } = useField<number>('comment');

// FUNCTIONS
function changeMarkerCategory(e) {
  emit('changeCategory', e);
}
</script>
<template>
  <div class="marker-questions">
    <div>{{ getLabel('map.selected-point.content', props.languageEnabled) }}</div>
    <div v-if="mapConfig.categories.length > 1">
      <div>{{ getLabel('map.selected-point.category', props.languageEnabled) }}</div>
      <base-select
        :ref="markerInputCategory"
        :options="
          props.mapConfig.categories.map((category) => ({
            label: getTranslation(category, 'name', languageEnabled),
            value: category.id,
          }))
        "
        @update="changeMarkerCategory($event)"
      />
    </div>
    <div>
      <div>{{ getLabel('map.selected-point.comment', props.languageEnabled) }}</div>
      <BaseInput v-model="comment" />
      <span class="error">{{ errorMessageComment }}</span>
    </div>
  </div>
</template>
<style lang="scss">
.marker-questions {
  display: flex;
  flex-direction: column;
  gap: $space-md;

  .q-field {
    &__control:before {
      border: 1px solid !important;
    }
  }
}
</style>
